import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageNotificationService } from 'message-notification-service-lib';
import { StandardWorkflowService, WorkflowTaskRunner } from 'workflow-task-service-lib';
import { environment } from '../../environments/environment';
import { ISaveAsDocxTaskConfig, SaveAsDocxTask } from '../classes/save-as-docx-task';

export type TaskCompleteCallback = () => void;

@Injectable({ providedIn: 'root' })
export class SaveAsDocxService {
  constructor(
    private http: HttpClient,
    private messageNotificationService: MessageNotificationService
  ) {}

  execute(config: ISaveAsDocxTaskConfig, taskComplete: TaskCompleteCallback): void {
    const workflowService = new StandardWorkflowService(
      this.http,
      environment.kpWorkflowHost,
      environment.kpWorkflowStatus
    );
    const saveToEntityTask: SaveAsDocxTask = new SaveAsDocxTask(
      config,
      taskComplete,
      this.messageNotificationService
    );
    const taskRunner = new WorkflowTaskRunner(workflowService, saveToEntityTask);
    taskRunner.run().subscribe({
      error: (error) => {
        this.messageNotificationService.error('The workflow could not be executed.', error);
        taskComplete();
      },
    });
  }
}
